module.exports = __webpack_public_path__ + "img/Content.aeaa634a.png";